module.exports = __webpack_public_path__ + "static/media/meter-tempth.a55a828f.svg";